import { render, staticRenderFns } from "./giftInventoryLog.vue?vue&type=template&id=09be86b4"
import script from "./giftInventoryLog.vue?vue&type=script&lang=js"
export * from "./giftInventoryLog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports